import * as React from "react"
import * as Antd from "antd"
import styles from "./ChatBackOffice.module.scss"

import { AppFunctions } from "@others/AppFunctions.ts"
import { ChannelSort, DefaultGenerics, StreamChat } from "stream-chat"

import {
	Chat,
	Channel,
	ChannelList,
	Window,
	MessageList,
	MessageInput,
	DefaultStreamChatGenerics,
} from "stream-chat-react"

import userService from "@services/userService/userService.ts"

const BACKOFFICE_USER_ID = AppFunctions.getViteEnv(
		"VITE_STREAM_BACKOFFICE_USER_ID"
	),
	BACKOFFICE_USER_NAME = "Distrito Globo",
	BACKOFFICE_USER_IMAGE =
		"https://membership.elglobodistrict.com/assets/images/globo_backoffice_avatar.jpg",
	filters = { members: { $in: [BACKOFFICE_USER_ID] }, type: "messaging" },
	options = { presence: true, state: true },
	sort = { last_message_at: -1 } as
		| ChannelSort<DefaultStreamChatGenerics>
		| undefined

interface IChatBackOfficeProps {
	className?: string
}

const ChatBackOffice: React.FC<IChatBackOfficeProps> = (props) => {
	const clientRef = React.useRef<StreamChat<DefaultGenerics>>()
	const clientRefInitialized = React.useRef(false)

	const [chatClient, setChatClient] =
		React.useState<StreamChat<DefaultGenerics>>()

	React.useEffect(() => {
		const initChat = async () => {
			if (clientRef.current) return

			clientRef.current = StreamChat.getInstance(
				AppFunctions.getViteEnv("VITE_STREAM_API_KEY")
			)

			await clientRef.current.connectUser(
				{
					id: BACKOFFICE_USER_ID,
					name: BACKOFFICE_USER_NAME,
					image: BACKOFFICE_USER_IMAGE,
				},
				async () => {
					if (AppFunctions.getViteEnv("VITE_USE_MOCKS"))
						return AppFunctions.getViteEnv(
							"VITE_STREAM_BACKOFFICE_USER_TOKEN"
						)

					const { token } = await userService.getUserChatToken()
					return token || ""
				}
			)

			setChatClient(clientRef.current)
		}

		initChat().then(() => {
			clientRefInitialized.current = true
		})

		return () => {
			if (clientRefInitialized.current) {
				clientRef.current?.disconnectUser()
				setChatClient(undefined)
			}
		}
	}, [])

	return (
		<div className={`${styles.chat_back_office} ${props.className || ""}`}>
			{chatClient && clientRef.current ? (
				<Chat client={clientRef.current}>
					<ChannelList
						sort={sort}
						filters={filters}
						options={options}
					/>
					<Channel>
						<Window>
							<MessageList
								messageActions={[
									"edit",
									"delete",
									"quote",
									"react",
									"reply",
								]}
							/>
							<MessageInput />
						</Window>
					</Channel>
				</Chat>
			) : (
				<Antd.Spin className={styles.spin} />
			)}
		</div>
	)
}

export default React.memo(ChatBackOffice)
